import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setIsOpen } from "@/store/modules/user";
import { useMemo } from "react";
import intl from "react-intl-universal";

const TitleWhithLine = ({ title, link }) => {
	const { userInfo } = useSelector(state => state.user)
	const useName = useMemo(() => userInfo?.username, [userInfo])
	const dispatch = useDispatch()

	const navigate = useNavigate();
	return (
		<div className={styles.linkTitle} onClick={() => {
			if (link) {
				if (link !== "discover/share" || useName) {
					navigate(link)
					window.scrollTo(0, 0);
					// setTimeout(() => {
					// }, 0);
				} else {
					dispatch(setIsOpen(true));
					localStorage.setItem("link", link)
				}

			} else {
				navigate('/second')
			}
		}}>
			{intl.get(title)}
		</div>
	)
}
export default TitleWhithLine
